export default "/_next/static/chunks/fonts/WorkSans-Regular-latin-897642919a926dd83f4437623e06daa8.woff2";